<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.76 48.759">
  <path class="filled" d="M47.9,42.743,36.558,31.4A20.086,20.086,0,1,0,31.4,36.558L42.743,47.9a2.921,2.921,0,0,0,4.13,0l1.032-1.032A2.919,2.919,0,0,0,47.9,42.743ZM20.049,32.8A12.749,12.749,0,1,1,32.8,20.048,12.763,12.763,0,0,1,20.049,32.8Z" fill="currentColor"/>
</svg>
